export default __webpack_public_path__ + "static/media/xsl.72b73a3d.svg";